import * as React from "react";

const BoltFilled = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.1211 21.9778" {...props}>
      <g>
        <rect height={21.9778} opacity={0} width={14.1211} x={0} y={0} />
        <path d="M0 12.1168C0 12.4977 0.292969 12.7809 0.703125 12.7809L6.2207 12.7809L3.31055 20.6911C2.92969 21.6969 3.97461 22.234 4.62891 21.4137L13.5059 10.32C13.6719 10.1149 13.7598 9.91958 13.7598 9.69497C13.7598 9.32388 13.4668 9.03091 13.0566 9.03091L7.53906 9.03091L10.4492 1.12075C10.8301 0.114895 9.78516-0.422214 9.13086 0.407864L0.253906 11.4918C0.0878906 11.7067 0 11.902 0 12.1168Z" />
      </g>
    </svg>
  );
};

export default BoltFilled;
